// Dinamik image URL utility
export const getImageUrl = (imageUrl, folder = '') => {
  if (!imageUrl) {
    return '/placeholder-image.jpg';
  }
  
  if (imageUrl.startsWith('/uploads/')) {
    const filename = imageUrl.replace('/uploads/', '');
    const baseUrl = process.env.REACT_APP_API_URL || 
                   (typeof window !== 'undefined' ? `${window.location.origin}/api` : 'http://localhost:5000/api');
    return `${baseUrl}/proxy/uploads/${folder}${folder ? '/' : ''}${filename}`;
  }
  
  return imageUrl;
};

export const getHomeImageUrl = (imagePath) => {
  if (!imagePath) return '';
  
  if (imagePath.startsWith('/uploads/')) {
    const baseUrl = process.env.REACT_APP_API_URL || 
                   (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5000');
    return `${baseUrl}${imagePath}`;
  }
  
  return imagePath;
};
